<div class="brief-icon" [attr.data-separator]="briefIconSeparator">
  <div class="item-icon" [ngStyle]="{ '-webkit-mask': 'url(' + briefIconUrl + ')', mask: 'url(' + briefIconUrl + ')' }"></div>
  <div class="item-label">{{ briefIconLabel }}</div>
</div>
